import { v4 as uuid } from "uuid";
import ILocation, { IOccupant } from "../../../types/ILocation";

const createBlankOccupant = (): IOccupant => {
  return {
    id: uuid(),
    name: "",
    types: ["Customer"],
    products: [
      {
        product: "",
        quantity: 0,
      },
    ],
    states: [],
  };
};

const createBlankLocation: () => ILocation = () => {
  return {
    id: uuid(),
    name: "",
    owner: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country: "USA",
    coordinates: [0, 0],
    uom: "ST",
    occupants: [createBlankOccupant()],
    inboundModes: ["TRUCK"],
    outboundModes: ["TRUCK"],
    modes: {
      TRUCK: {
        name: "TRUCK",
        inbound: true,
        outbound: true,
      },
      RAIL: {
        name: "RAIL",
        inbound: false,
        outbound: false,
      },
      VESSEL: {
        name: "VESSEL",
        inbound: false,
        outbound: false,
      },
      BARGE: {
        name: "BARGE",
        inbound: false,
        outbound: false,
      },
      PIPELINE: {
        name: "PIPELINE",
        inbound: false,
        outbound: false,
      },
    },
    carriers: [],
    pinType: "koch",
  } as any;
};

export { createBlankLocation, createBlankOccupant };
